// Most of this plugin has been borrowed from the setSameHeight function that Katie added tofor Swipe.js.

; define('core/ef_plugins/equalheight',["jquery", "core/global/state", "underscore", "libs/jquery.imagesloaded"], function (jQuery, state, _) {
    (function ($, window, document, undefined) {

        var pluginName = 'equalheight',
            defaults = {
                refreshTime: 100, // Time in ms between window.resize and adjusting the height of the elements
                childSelector: '' // Optional: filter out the child elements to call the plugin on
            };

        // The actual plugin constructor
        function Equalheight(element, options) {
            // grab the element the plugin was called on
            this.element = element;

            // also save the element as a jquery object
            this.$element = $(element);

            // get per-element inline configuration settings
            this.metadata = this.$element.data('equalheight-options');

            // merge all the configs
            this.options = $.extend({}, defaults, options, this.metadata);

            // save the defaults
            this._defaults = defaults;

            // save the plugin name
            this._name = pluginName;

            // call init function
            this.init();
        }

        // Define this sucker
        Equalheight.prototype = {
            init: function () {
                // TODO: ugh so we need to wait for images to fully load before changing height and the easiest way to do that
                // is to use a jquery plugin :/
                // this might be useful for the future http://www.sajithmr.me/javascript-check-an-image-is-loaded-or-not
                var plugin = this,
                    imagesLoadedHandle,
                    debouncedUpdateListItemHeights;

                function updateListItemHeights() {
                    // plug-in will select the wrong elements if called destroy from outside
                    // TODO: find a way to move the destroy call into global.js.
                    if ((state.getBreakpoint() < 640) && ($('.content-list-from-carousel').is('.list'))) {
                        plugin.setListToAutoHeight();
                    } else {
                        plugin.updateCardHeights();
                    }
                }

                debouncedUpdateListItemHeights = _.debounce(updateListItemHeights, 200);
                //_.defer(function() {
                // Defer runs this code after the call stack has cleared, similar to setting a timeout of 0 seconds.
                // This causes imagesLoaded to run after picturefill replaces the span tags with images.
                // Once picturefill has been removed, we can call imagesLoaded outside of defer.
                imagesLoadedHandle = $(plugin.element).imagesLoaded(function () {
                    updateListItemHeights();
                });
                //});

                if ($('html').hasClass('lt-ie9')) {
                    return;
                }

               $(window).on('resize.equalheight', function () { // Namespace event so we can safely unbind in .destroy()
                   debouncedUpdateListItemHeights();
                });
            },

            setListToAutoHeight: function () {
                //if we want no cards but a list view we have to let the content fill up the available space
                var plugin = this,
                    children = $(plugin.options.childSelector);

                  children.css('height', 'auto');
            },
              updateCardHeights: function () {
                // re-reference the plugin to avoid this conflicts
                var plugin = this,
                    children, // A collection of the children of plugin.element. We'll be setting the height of these elements.
                    currentEl, // Element currently being resized
                    index,
                    topHeight = 0, // The height of the tallest element in children
                    testHeight = 0,
                    $currentEl;

                if (plugin.options.childSelector === '') {
                    children = plugin.$element.children().get();
                } else {
                    children = plugin.$element.children(plugin.options.childSelector).get();
                }

                // uy Using $.children() instead of DOM childNodes, we avoid getting text nodes.
                if (children.length === 0) {
                    return false; // Nothing to resize
                }

                index = children.length;

                // reset height to auto
                while (index--) {
                    currentEl = children[index];
                    currentEl.style.height = 'auto';
                }

                // reset index
                index = children.length;

                //find the tallest element
                while (index--) {
                    currentEl = children[index];
                    $currentEl = $(currentEl);
                    // We're using jQuery to get the height because IE8 doesn't support getComputedStyle.
                    // This script previously used getComputedStyle, so that code is available in TFS if you want to switch back.                   

                    // Check if element has border-box apply, if it does use outerHeight(), if not use height()
                    testHeight = $currentEl.css("box-sizing") == "border-box" ? $currentEl.outerHeight() : $currentEl.height();
                    if (testHeight > topHeight) {
                        topHeight = testHeight;
                    }
                }
                //reset index
                index = children.length;

                // set style of each slide
                while (index--) {
                    currentEl = children[index];
                    currentEl.style.height = topHeight + 'px';
                }
                return true; // We've successfully resized all the children.
            },
            destroy: function () {
                // whatever you need to do to destroy this sucka goes here
                // remove event handlers, put html back where it was, etc.

                var plugin = this;

                if (!$('html').hasClass('lt-ie9')) {
                    $(window).off('resize.equalheight');
                }

                plugin.$element.children().height('');

                // remove the data
                plugin.$element.removeData('plugin_' + pluginName);
            }
        };

        // Turn this into a jquery plugin & prevent multiple instantiations
        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new Equalheight(this, options));
                }
            });
        };

    })(jQuery, window, document);
});
